fragment FilteredInvoiceFragment on Invoice {
    id
    modalUrl
    displayNumber
    displayStatus
    slug
    statusLog
    shareableViewInBrowserLink
    preparedTimeFormatted
    validUntilDateFormatted
    sentTime
    createdTime
    publishedTime
    acceptedTime
    modifiedTime
    total {
        amount
        formattedWithCents
    }
    creatorUser {
        id
        name
    }
    lead {
        id
        name
        htmlUrl
        assignee {
            id
            name
        }
    }
    overdueDuration
    hasBeenViewed
}
